import AddResource from '../modals/AddResource';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import ResourcesCards from './ResourcesCards';
import {useState} from "react";
import {SearchByFilters} from "../../../reduxToolkit/Search/SearchApi";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ResourcesTab = ({
      view,
      option,
      setBodyForExport,
      selectedList,
      setSelectedList,
      searchElement,
      setSearchElement,
      isAllChecked,
      setIsAllChecked,
      modified,
      setModified,
      setSearch,
      simpleSearch,
      setSimpleSearch,
    addResourceShow,
    setAddResourceShow
}) => {
    const [currImg, setCurrImg] = useState(null);
    const [openViewer, setOpenViewer] = useState(false);
    const imageArray = (SearchByFilters?.content || []).map((item) => ({
        src: `data:image/png;base64,${item?.image}`,
    }));

    return (
        <>
            <ResourcesCards
                view={view}
                option={option}
                setBodyForExport={setBodyForExport}
                selectedList={selectedList}
                setSelectedList={setSelectedList}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                isAllChecked={isAllChecked}
                setIsAllChecked={setIsAllChecked}
                modified={modified}
                setModified={setModified}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                setOpenViewer={setOpenViewer}
                setCurrImg={setCurrImg}
            />

            <AddResource
                open={addResourceShow}
                onClose={() => setAddResourceShow(false)}
                onUpdated={() => setModified(true)}
            />
            <Lightbox
                open={openViewer}
                close={() => setOpenViewer(false)}
                slides={imageArray}
                index={imageArray.findIndex((item) => item.src === currImg)}
            />
        </>
    );
};
export default ResourcesTab;
